module.exports = __webpack_public_path__ + "img/main-game-bg.9ee3e87f.svg";